import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/education')({
  component: EducationIndustryPage,
});

function EducationIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="education" />
    </DefaultLayout>
  );
}
